"use client";

import React from "react";
import { Button, ButtonProps } from "@material-tailwind/react";

interface PrimaryButtonProps extends Omit<ButtonProps, 'ref'> {
    children: React.ReactNode;
    className?: string;
}

interface SecondaryButtonProps extends Omit<ButtonProps, 'ref'> {
    children: React.ReactNode;
    className?: string;
}

export function PrimaryButton({ children, className = "", disabled, ...props }: PrimaryButtonProps) {
    return (
        <Button
            size="lg"
            className={`text-white flex items-center justify-center gap-2 transition-all rounded-lg ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
            style={{
                backgroundColor: disabled ? '#8BA8D4' : '#0055D4',
                cursor: disabled ? 'not-allowed' : 'pointer'
            }}
            onMouseEnter={(e) => !disabled && (e.currentTarget.style.backgroundColor = '#0044B3')}
            onMouseLeave={(e) => !disabled && (e.currentTarget.style.backgroundColor = '#0055D4')}
            disabled={disabled}
            {...props}
        >
            {children}
        </Button>
    );
}

export function SecondaryButton({ children, className = "", disabled, ...props }: SecondaryButtonProps) {
    return (
        <Button
            size="lg"
            variant="outlined"
            className={`transition-all rounded-lg flex items-center justify-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-50'} ${className}`}
            style={{
                borderColor: disabled ? '#8BA8D4' : '#0055D4',
                color: disabled ? '#8BA8D4' : '#0055D4',
                cursor: disabled ? 'not-allowed' : 'pointer'
            }}
            disabled={disabled}
            {...props}
        >
            {children}
        </Button>
    );
}